import styled, { css } from 'styled-components';
import { getBreakpointsForHeaderVersion } from 'src/components/ZillowNavbar/utils/getBreakpointsForHeaderVersion';
import { WhiteZillowLogo } from './WhiteZillowLogo';
import { InternalLogoProps } from './InternalLogoProps';

export const SizedMobileSizeZillowLogo = styled(WhiteZillowLogo)<InternalLogoProps>`
    ${({ version, isMobileNavOpen }) => css`
        display: none;
        ${!isMobileNavOpen &&
        css`
            @media (max-width: ${getBreakpointsForHeaderVersion(version).MOBILE}px) {
                display: block;
            }
        `}
    `}
`;
